import { 
    AlertDialog, 
    AlertDialogBody, 
    AlertDialogContent, 
    AlertDialogFooter, 
    AlertDialogHeader, 
    AlertDialogOverlay, 
    Button, 
    Divider, 
    Flex, 
    Text
} from "@chakra-ui/react";
import { useCreditCard } from "@/hooks/useCreditCard";
import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "@/utils";
import { TrashIcon2 } from "@/styles/icons/TrashIcon2";
import { useAsyncFunction } from "@/hooks/useAsyncFunction";

interface DeleteCreditCardProps {
    isOpen: boolean;
    onClose: ()=> void;
}
export default function DeleteCreditCard({isOpen, onClose}: DeleteCreditCardProps) {
    const { 
        deleteCreditCard
    } = useCreditCard();
    const modalRef = useRef();
    const { id } = useParams();
    const navigate = useNavigate();
    const { execute, loading } = useAsyncFunction(deleteCreditCard);
    async function onSubmit() {
        try {
            await execute(id);
            navigate("/cartao");
            showToast({
                type: "success",
                message: `Cartão deletado com sucesso.`,
            });       
        } catch (error) {
            error?.response?.data?.errors.map((error) => {
            showToast({
                type: "error",
                message: `${error?.code} - ${error?.description}`,
            });
        });
        } finally {
            onClose();
        }
    }
    return (
        <AlertDialog
            isOpen={isOpen}
            onClose={onClose}
            leastDestructiveRef={modalRef}
            motionPreset="slideInBottom"
            isCentered
        >
        <AlertDialogOverlay>
            <AlertDialogContent
                display="flex"
                flexDir="column"
                borderRadius=".5rem"
                w="400px"
            >
                <AlertDialogHeader
                    p="16px 24px" 
                    fontSize="1rem" 
                    fontWeight="bold"
                >
                    <Flex
                        align="center"
                        gap="4"
                    >
                        <TrashIcon2 />
                        <Text
                            fontSize="1rem"
                            fontWeight={600}
                        >
                            Cancelar cartão
                        </Text>
                    </Flex>
                </AlertDialogHeader>
                <Divider />
                <AlertDialogBody
                    margin="0"
                    px="1rem"
                    py="1rem"
                    w="100%"
                >
                    <Flex
                        w="100%"
                        flexDirection="column"
                        gap="1rem"
                    >
                        <Text
                            fontSize="14px"
                        >
                            Você quer cancelar esse cartão definitivamente?
                        </Text>
                        <Text
                            fontSize="14px"
                        >
                            Qualquer recorrência futura ou compra que ainda não tenha sido aprovada com esse cartão, não será aprovada.
                        </Text>
                        <Text
                            fontSize="12px"
                            color="red.400"
                            fontWeight={600}
                        >
                            Essa ação não poderá ser desfeita.
                        </Text>
                    </Flex>
                </AlertDialogBody>
                <Divider />
                <AlertDialogFooter
                    h="5rem"
                    w="100%"
                    display="flex"
                    gap="4"
                >
                    <Button
                        variant="secondary"
                        size="sm"
                        borderRadius=".5rem"
                        fontWeight={400}
                        transition="filter .2s"
                        _hover={{
                            transition: "filter .2s",
                            filter: "brightness(.9)",
                        }}
                        _focus={{}}
                        onClick={onClose}
                    >
                        Voltar
                    </Button>
                    <Button
                        variant="primary2"
                        size="sm"
                        borderRadius=".5rem"
                        fontWeight={400}
                        transition="filter .2s"
                        _hover={{
                            transition: "filter .2s",
                            filter: "brightness(.9)",
                        }}
                        _focus={{}}
                        onClick={onSubmit}
                        isLoading={loading}
                        isDisabled={loading}
                    >
                        Cancelar cartão
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialogOverlay>
        </AlertDialog>
    );
};
